export default "__VITE_ASSET__BIWrmiMX__"